import { render, staticRenderFns } from "./VideoWebview.vue?vue&type=template&id=77b7d2fa&"
import script from "./VideoWebview.vue?vue&type=script&lang=js&"
export * from "./VideoWebview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports